import { Heading, ModalCloseButton } from '@orobix/orobix-fe-components'
import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useStyles } from './FullscreenModal.styles'

type FullscreenModalProps = {
  title: string
  onCloseRequest: () => void
  children: React.ReactNode
}

export const FullscreenModal = ({
  title,
  onCloseRequest,
  children,
}: FullscreenModalProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const handleKeyUp = (e: KeyboardEvent): void => {
    const keys = {
      Escape: (): void => {
        e.preventDefault()
        onCloseRequest()
        window.removeEventListener('keyup', handleKeyUp)
      },
    }

    if (keys[e.key as keyof typeof keys]) {
      keys[e.key as keyof typeof keys]()
    }
  }

  const keyUpCallback = useCallback(handleKeyUp, [handleKeyUp, onCloseRequest])

  useEffect(() => {
    document.body.classList.add(classes.modalOpen)
    window.addEventListener('keyup', keyUpCallback)

    return (): void => {
      document.body.classList.remove(classes.modalOpen)
      window.removeEventListener('keyup', keyUpCallback)
    }
  }, [keyUpCallback, classes.modalOpen])

  return (
    <div className={classes.modal} role="document">
      <div className={classes.modalContainer}>
        <div className={classes.modalHeader}>
          <Heading headingLevel="5" noTopMargin noBottomMargin>
            <span className={classes.title}>{title}</span>
          </Heading>
          <div>
            <ModalCloseButton onClick={onCloseRequest} label={t('Close')} />
          </div>
        </div>

        <div className={classes.modalContent}>{children}</div>
      </div>
    </div>
  )
}
